import * as angular from 'angular';
import {RootScope} from '../types/angular-types';

angular.module('GorillaBoy.directives')
    .directive('infoBoxStyle', [
        '$rootScope',
        function viewButton($rootScope: RootScope) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                $element.addClass('info-box');
                $element.addClass('fadeInOutAnimation');
            }
        };
    }]);